
import React from "react";
import { Check } from "lucide-react";
import { motion } from "framer-motion";
import { useCommunity } from "@/contexts/CommunityContext";

export const BusinessRegistrationLeftPanel: React.FC = () => {
  const { currentCommunity } = useCommunity();
  const communityName = currentCommunity?.name ?? "our community";

  return (
    <div className="px-8 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="space-y-8"
      >
        <div className="space-y-6">
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground leading-tight">
            Grow Your Business with
            <br />
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-primary to-primary/80">
              {communityName}
            </span>
          </h2>
        </div>
        
        <div className="space-y-4">
          <div className="flex items-start">
            <div className="flex-shrink-0 mt-0.5">
              <div className="h-6 w-6 rounded-full bg-primary flex items-center justify-center">
                <Check className="h-4 w-4 text-primary-foreground" />
              </div>
            </div>
            <div className="ml-4">
              <p className="text-base">Reach a dedicated community of potential customers actively looking for local services</p>
            </div>
          </div>
          
          <div className="flex items-start">
            <div className="flex-shrink-0 mt-0.5">
              <div className="h-6 w-6 rounded-full bg-primary flex items-center justify-center">
                <Check className="h-4 w-4 text-primary-foreground" />
              </div>
            </div>
            <div className="ml-4">
              <p className="text-base">Build trust with community-verified status that signals quality and reliability</p>
            </div>
          </div>
          
          <div className="flex items-start">
            <div className="flex-shrink-0 mt-0.5">
              <div className="h-6 w-6 rounded-full bg-primary flex items-center justify-center">
                <Check className="h-4 w-4 text-primary-foreground" />
              </div>
            </div>
            <div className="ml-4">
              <p className="text-base">Connect directly with customers through our in-app messaging platform</p>
            </div>
          </div>
          
          <div className="flex items-start">
            <div className="flex-shrink-0 mt-0.5">
              <div className="h-6 w-6 rounded-full bg-primary flex items-center justify-center">
                <Check className="h-4 w-4 text-primary-foreground" />
              </div>
            </div>
            <div className="ml-4">
              <p className="text-base">Promote special offers and discounts to attract new customers and grow your business</p>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default BusinessRegistrationLeftPanel;
